const incrementClickCount = () => ({
  type: 'INCREMENT_CLICK_COUNT',
});

export const miqCustomTabActions = {
  incrementClickCount,
};
